import api from '../api';

export interface Cargo {
    id: number;
    nome: string;
    empresa_id: number;
}

export class CargoService {
    /**
     * Busca um cargo pelo nome e empresa_id, ou cria se não existir
     */
    static async findOrCreate(nome: string, empresaId: number): Promise<Cargo> {
        try {
            const response = await api.post<Cargo>('cargos/find-or-create', {
                nome,
                empresa_id: empresaId,
            });
            return response.data;
        } catch (error: any) {
            throw new Error(error.response?.data?.message || 'Erro ao buscar/criar cargo');
        }
    }
}
